import PropTypes from 'prop-types';
import React from 'react';

import DatePickerRedux from '../../common/DatePickerRedux';
import CurrencyInput from '../../common/currencyInput';
import { stripWhitespace } from '../../common/formFields/normalizers';
import Input from '../../common/input';
import Checkbox from '../../common/simpleCheckbox';
import Modal from '../../common/Modal';
import { PROMO_TYPE } from '../../main/settings/promoCodes/constants';
import Select from '../../common/select';
import { t } from '../../../modules/infra/i18n';

const AddPromoModal = ({
  handleSubmit,
  pristine,
  submitting,
  valid,
  close,
  onKindChange,
  isPercentage,
  dateFormat,
}) => (
  <Modal
    showHeader={false}
    close={close}
  >
    <div className="u-bg-white u-pt-">
      <h2 className="c-heading u-ml">
        {t('engage:promo.add_title')}
      </h2>
      <form className="u-mt+" onSubmit={handleSubmit}>
        <fieldset disabled={submitting} className="u-margin-auto u-max-width-360">
          <div className="o-tableize o-tableize--middle">
            <div className="o-tableize__row">
              <div className="o-tableize__cell u-text-center u-pb-">
                <label className="c-label-new" htmlFor="name">{t('engage:promo.name')}</label>
              </div>
              <div className="o-tableize__cell o-tableize__cell--fill u-pl u-pb-">
                <Input
                  className="c-input u-1/1"
                  name="code"
                  type="text"
                  placeholder={t('engage:promo.name_placeholder')}
                  normalize={stripWhitespace}
                />
              </div>
            </div>
            <div className="o-tableize__row">
              <div className="o-tableize__cell u-text-center u-pb-">
                <label className="c-label-new" htmlFor="name">{t('engage:promo.type')}</label>
              </div>
              <div className="o-tableize__cell o-tableize__cell--fill u-pl u-pb-">
                <Select
                  name="kind"
                  className="c-select u-1/1"
                  onChange={onKindChange}
                  parse={value => parseInt(value, 10)}
                  options={[{
                    label: t('engage:promo.fixed_amount'),
                    value: PROMO_TYPE.amount,
                  }, {
                    label: t('engage:promo.percentage'),
                    value: PROMO_TYPE.percentage,
                  }]}
                />
              </div>
            </div>
            <div className="o-tableize__row">
              <div className="o-tableize__cell u-text-center u-pb-">
                <label className="c-label-new" htmlFor="value">{t('engage:promo.value')}</label>
              </div>
              <div className="o-tableize__cell o-tableize__cell--fill u-pl u-pb-">
                <CurrencyInput
                  className="c-input u-1/1"
                  name="value"
                  placeholder="$0.00"
                  display-if={!isPercentage}
                />
                <Input
                  className="c-input u-1/1"
                  name="value"
                  type="number"
                  placeholder={t('engage:promo.value_placeholder')}
                  prefix="%"
                  display-if={isPercentage}
                />
              </div>
            </div>
            <div className="o-tableize__row">
              <div className="o-tableize__cell u-text-center u-pb-">
                <label className="c-label-new" htmlFor="expirationDate">{t('engage:promo.expiration')}</label>
              </div>
              <div className="o-tableize__cell o-tableize__cell--fill u-pl u-pb-">
                <DatePickerRedux
                  className="c-input u-1/1"
                  name="expirationDate"
                  addClearBtn
                  startDate={new Date()}
                  placeholder={dateFormat}
                  defaultValue={''}
                />
              </div>
            </div>
            <div className="o-tableize__row">
              <div className="o-tableize__cell" />
              <div className="o-tableize__cell o-tableize__cell--fill u-pl u-pv">
                <Checkbox
                  id="firstAppointmentOnly"
                  name="firstAppointmentOnly"
                  label={t('engage:promo.new_clients_only')}
                />
              </div>
            </div>
            <div className="o-tableize__row">
              <div className="o-tableize__cell" />
              <div className="o-tableize__cell o-tableize__cell--fill u-pl u-pv">
                <Checkbox
                  id="oneTime"
                  name="oneTime"
                  label={t('engage:promo.one_time')}
                />
              </div>
            </div>
          </div>
        </fieldset>
        <hr className="c-separator u-mt" />
        <div className="u-p o-flexbox">
          <button
            className="c-btn c-btn--grey u-width-120 u-2/5 u-1/3-medium-and-up"
            type="button"
            onClick={close}
            disabled={submitting}
          >
            {t('engage:buttons.cancel')}
          </button>
          <button
            className="c-btn u-width-120 u-2/5 u-1/3-medium-and-up"
            type="submit"
            disabled={!valid || submitting || pristine}
          >
            {t('engage:promo.save')}
          </button>
        </div>
      </form>
    </div>
  </Modal>
);
AddPromoModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  onKindChange: PropTypes.func.isRequired,
  isPercentage: PropTypes.bool,
  dateFormat: PropTypes.string.isRequired,
};

AddPromoModal.defaultProps = {
  isPercentage: false,
};

export default AddPromoModal;
